import { Field } from 'formik';
import FormField from './FormField';

import NumberInput from './NumberInput';

// If you need to extend NumberInput functionality keep in mind that {...props} is on FormControl to support all Chakra props
// Specific props for NumberInput should be excluded from ...props and manually added
const NumberInputFormikField = ({
    id,
    name,
    label,
    placeholder,
    precision,
    step,
    min,
    max,
    hasStepperButtons,
    leftElement,
    rightElement,
    ...props
}) => (
    <Field name={name}>
        {({ field, meta, form }) => (
            <FormField
                id={id}
                name={name}
                label={label}
                isInvalid={meta.error && meta.touched}
                error={meta.error}
                {...props}
            >
                <NumberInput
                    // {...field} also contains onChange, which we overwrite
                    {...field}
                    // zDefaultValue could be returned and Chakra uses toString(value)
                    value={Number.isNaN(Number.parseFloat(field.value)) ? '' : field.value}
                    onChange={(value) => form.setFieldValue(name, value)}
                    placeholder={placeholder}
                    precision={precision}
                    step={step}
                    max={max}
                    min={min}
                    leftElement={leftElement}
                    rightElement={rightElement}
                    hasStepperButtons={hasStepperButtons}
                />
            </FormField>
        )}
    </Field>
);

export default NumberInputFormikField;
